export const CONTAINER_CLASS = "max-w-7xl mx-auto px-4 lg:p-auto";
